import { Types } from '@grandvisionhq/graphql';
import { isDefined, getLocalizedString, formatPrice } from '@grandvisionhq/utils';
import '../../../types/product.js';
import { SINGLE_PURCHASE, SUBSCRIPTION_PURCHASE, IN_STORE_SUBSCRIPTION_PURCHASE } from '../../../types/purchase-types.js';

const getDiscountBadge = (locale, currency, serverDiscountedPrice)=>{
    if (!serverDiscountedPrice || !serverDiscountedPrice.discountInformation) {
        return undefined;
    }
    const { type , value  } = serverDiscountedPrice.discountInformation;
    if (!value) {
        return undefined;
    }
    if (type === Types.DiscountType.RELATIVE) {
        return `-${value}%`;
    }
    if (type === Types.DiscountType.ABSOLUTE) {
        const formattedDiscount = formatPrice({
            locale,
            value,
            currency,
            isCentAmount: false
        });
        return `-${formattedDiscount}`;
    }
};
const getPurchaseTypePrice = (serverPrice, locale)=>{
    var ref, ref1, ref2, ref3;
    if (!serverPrice || !serverPrice.originalPrice) {
        return undefined;
    }
    const currency = serverPrice.originalPrice.currencyCode;
    const originalPrice = serverPrice.originalPrice.amount;
    const discountedPrice = (ref = serverPrice.discountedPrice) === null || ref === void 0 ? void 0 : (ref1 = ref.price) === null || ref1 === void 0 ? void 0 : ref1.amount;
    let discountInfo;
    if (isDefined(discountedPrice)) {
        var _discountedPrice;
        const { discountInformation  } = (_discountedPrice = serverPrice.discountedPrice) !== null && _discountedPrice !== void 0 ? _discountedPrice : {};
        const { description , validity  } = discountInformation !== null && discountInformation !== void 0 ? discountInformation : {};
        const discountBadge = getDiscountBadge(locale, currency, serverPrice.discountedPrice);
        const discountDescription = description && getLocalizedString(description, locale);
        var ref4, ref5;
        discountInfo = {
            discountDescription,
            discountBadge,
            validFrom: (ref4 = validity === null || validity === void 0 ? void 0 : validity.validFrom) !== null && ref4 !== void 0 ? ref4 : undefined,
            validUntil: (ref5 = validity === null || validity === void 0 ? void 0 : validity.validUntil) !== null && ref5 !== void 0 ? ref5 : undefined
        };
    }
    const loyaltyPoints = serverPrice.loyaltyPoints;
    // pricePerUnit may be 0 on the BE, in which case set it to undefined on the FE
    const pricePerUnit = !!((ref2 = serverPrice.pricePerUnit) === null || ref2 === void 0 ? void 0 : ref2.amount) ? (ref3 = serverPrice.pricePerUnit) === null || ref3 === void 0 ? void 0 : ref3.amount : undefined;
    return {
        currency,
        isCentAmount: false,
        originalPrice,
        discountedPrice,
        discountInfo,
        loyaltyPoints,
        pricePerUnit
    };
};
const getPurchaseTypePrices = (serverPriceList, locale, priceSegmentChannelKey)=>{
    const singlePurchasePriceListRaw = serverPriceList.filter((price)=>price.priceType === Types.ProductPriceItemType.SINGLE_PURCHASE
    );
    const singlePurchasePriceSegmentRaw = singlePurchasePriceListRaw.find((price)=>{
        var ref;
        return ((ref = price.priceSegment) === null || ref === void 0 ? void 0 : ref.channelKey) === priceSegmentChannelKey;
    });
    const singlePurchasePriceDefaultRaw = singlePurchasePriceListRaw.find((price)=>{
        var ref;
        return !((ref = price.priceSegment) === null || ref === void 0 ? void 0 : ref.channelKey);
    });
    const subscriptionPurchasePriceRaw = serverPriceList.find((price)=>price.priceType === Types.ProductPriceItemType.SUBSCRIPTION
    );
    const singlePurchasePrice = getPurchaseTypePrice(singlePurchasePriceSegmentRaw || singlePurchasePriceDefaultRaw, locale);
    const subscriptionPurchasePrice = getPurchaseTypePrice(subscriptionPurchasePriceRaw, locale);
    const inStoreSubscriptionPurchasePrice = getPurchaseTypePrice(singlePurchasePriceDefaultRaw, locale);
    if (!singlePurchasePrice) {
        return undefined;
    }
    return {
        [SINGLE_PURCHASE]: singlePurchasePrice,
        [SUBSCRIPTION_PURCHASE]: subscriptionPurchasePrice,
        [IN_STORE_SUBSCRIPTION_PURCHASE]: inStoreSubscriptionPurchasePrice
    };
};

export { getPurchaseTypePrices };
//# sourceMappingURL=get-purchase-type-prices.js.map
